import { axiosGet } from './axiosGet';
import { devError } from './devLog';

export const getUserRoles = async (user) => {
  const { id, fellowId } = user;
  const roles = ['default'];
  try {
    if (id) {
      const refereeResult = await axiosGet(
        `referee-reports?filters[refereeUserId][$eq]=${id}&filters[refereeArchived][$eq]=false`,
      );

      if (refereeResult && refereeResult?.data?.data?.length !== 0) {
        roles.push('referee');
      }

      const adminResult = await axiosGet(
        `admins?filters[users_permissions_user][id][$eq]=${id}&populate=*`,
      );

      if (adminResult && adminResult?.data?.data?.length !== 0) {
        roles.push('admin');
      }

      const secretaryResult = await axiosGet(
        `secretaries?filters[users_permissions_user][id][$eq]=${id}&populate=*`,
      );

      if (secretaryResult && secretaryResult?.data?.data?.length !== 0) {
        roles.push('secretary');
      }

      const superAdminResult = await axiosGet(
        `super-admins?filters[users_permissions_user][id][$eq]=${id}&populate=*`,
      );

      if (superAdminResult && superAdminResult?.data?.data?.length !== 0) {
        roles.push('super-admin');
      }

      const committeeResponse = await axiosGet(`chair-committees?populate=*`);

      if (committeeResponse && committeeResponse?.data?.data?.length > 0) {
        const committees = committeeResponse.data.data;

        const isChair = committees.some(
          (committee) =>
            committee.attributes?.committeeChair?.data?.id === parseInt(id),
        );
        if (isChair) {
          roles.push('committee-chair');
        }

        const isMember = committees.some((committee) =>
          committee.attributes?.committeeMembers?.data?.some(
            (member) => member.id === parseInt(id),
          ),
        );
        if (isMember) {
          roles.push('committee-member');
        }

        const isObserver = committees.some((committee) =>
          committee.attributes?.councilObservers?.data?.some(
            (observer) => observer.id === parseInt(id),
          ),
        );
        if (isObserver) {
          roles.push('council-observer');
        }
      }

      const adminActionResult = await axiosGet('admin-action');
      const enableCouncilMembers =
        adminActionResult?.data?.data?.attributes?.enableCouncilMembers ??
        true;

      const councilMemberResult = await axiosGet(
        `council-members?filters[users_permissions_user][id][$eq]=${id}&populate=*`,
      );

      if (
        councilMemberResult &&
        councilMemberResult?.data?.data?.length !== 0 &&
        enableCouncilMembers
      ) {
        roles.push('council-member');
      }
    }

    if (fellowId) {
      const fellowResult = await axiosGet(
        `fellows?filters[id][$eq]=${fellowId}`,
      );
      if (fellowResult && fellowResult?.data?.data?.length !== 0) {
        const fellowData = fellowResult.data.data[0];

        if (fellowData?.attributes?.isCorrespondingMember === true) {
          roles.push('fellow-corresponding-member');
        } else {
          roles.push('fellow');
        }
      }
    }
  } catch (error) {
    devError('Error checking user roles:', error);
    return false;
  }

  return roles;
};
